import { Box, Button, Skeleton } from "@mui/material";
import { API_URL, BootstrapTooltip } from "../../utilities";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  GridActionsCellItem,
  GridColDef,
  GridRenderCellParams,
  GridRowId,
  GridRowModel,
  GridRowModes,
  GridRowModesModel,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import moment from "jalali-moment";
import GridViewMUIX from "../../components/GridViewMUIX";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useAuth } from "../../context/auth";
import { MouseEvent, useEffect, useState } from "react";
import { useNotifications } from "@toolpad/core/useNotifications";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";

import PopoverComponent from "../../components/PopoverComponent";
import NewProvince from "./new-province";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import SkeltonProgress from "../../components/SkeltonProgress";
import Cities from "./cities";
import { ICity } from "src/interface/ICity";
import { IUser } from "src/interface/IUser";
import { IProvince } from "src/interface/IProvince";
const Province = () => {
  const notifications = useNotifications();
  const { user } = useAuth();
  const { isLoading, error, data, refetch } = useQuery({
    queryKey: ["ProvincesData"],
    queryFn: () =>
      fetch(API_URL + "provinces", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Aceept: "application/json",
        },
      }).then((res) => res.json()),
  });
  const [rows, setRows] = useState<any>();
  const [openNewProvince, setOpenNewProvince] = useState<boolean>(false);

  useEffect(() => {
    if (error) {
      notifications.show("خطا در دریافت اطلاعات" + error.toString(), {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log(error);
    }
  }, [error]);

  useEffect(() => {
    data && setRows(data);
  }, [data, user?.token]);
  const [rowModesModel, setRowModesModel] = useState<GridRowModesModel>({});

  const columns: GridColDef[] = [
    {
      field: "name",
      headerName: "نام",
      flex: 1,
      filterable: true,
      align: "left",
      headerAlign: "left",
      editable: true,
      sortable: true,
    },
    {
      field: "lat&long",
      minWidth: 180,
      align: "center",
      headerAlign: "center",

      headerName: "موقعیت مکانی",
      editable: true,
      sortable: true,
      renderCell: (params: GridRenderCellParams<any, string>) =>
        params.row.lat && "(" + params.row.lat + "," + params.row.long + ")",
    },

    {
      field: "createdOn",
      headerName: "تاریخ ثبت",
      sortable: true,
      headerAlign: "center",
      align: "center",
      renderCell: (params: GridRenderCellParams<any, string>) =>
        `${
          params.value &&
          moment.from(params.value, "en", "YYYY-MM-DD").format("jYYYY/jMM/jDD")
        }`,
    },
    {
      field: "modifiedOn",
      headerName: "آخرین تغییرات",
      headerAlign: "center",
      align: "center",
      sortable: true,
      renderCell: (params: GridRenderCellParams<any, string>) =>
        `${
          params.value &&
          moment.from(params.value, "en", "YYYY-MM-DD").format("jYYYY/jMM/jDD")
        }`,
    },
    {
      field: "actions",
      type: "actions",
      headerAlign: "center",
      headerName: "عملیات",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      cellClassName: "actions",
      minWidth: 150,
      getActions: (params) => {
        const isInEditMode =
          rowModesModel[params.id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <BootstrapTooltip title="ذخیره">
              <GridActionsCellItem
                icon={<SaveIcon color="success" />}
                label="Save"
                sx={{
                  color: "primary.main",
                }}
                onClick={handleSaveClick(params.id)}
              />
            </BootstrapTooltip>,
            <BootstrapTooltip title="انصراف">
              <GridActionsCellItem
                icon={<CancelIcon color="error" />}
                label="Cancel"
                className="textPrimary"
                onClick={handleCancelClick(params.id)}
                color="inherit"
              />
            </BootstrapTooltip>,
          ];
        }

        return [
          <BootstrapTooltip title="ویرایش">
            <GridActionsCellItem
              icon={<EditIcon color="primary" />}
              label="ویرایش"
              className="textPrimary"
              onClick={handleEditClick(params.id)}
              color="inherit"
            />
          </BootstrapTooltip>,
          <BootstrapTooltip title="حذف">
            <GridActionsCellItem
              icon={<DeleteIcon color="error" />}
              label="حذف"
              onClick={(event) =>
                handleDeleteClick(event, params.id.toString())
              }
              color="inherit"
            />
          </BootstrapTooltip>,
          <BootstrapTooltip title="مشاهده شهر ها">
            <GridActionsCellItem
              icon={<LocationCityIcon color="primary" />}
              label="مشاهده شهر ها"
              onClick={(event) =>
                handleShowCitiesClick(params.row as IProvince)
              }
              color="inherit"
            />
          </BootstrapTooltip>,
          // <BootstrapTooltip title="موقعیت">
          //   <GridActionsCellItem
          //     icon={<LocationOnIcon color="primary" />}
          //     label="موقعیت"
          //     onClick={(event) =>
          //       handleDeleteClick(event, params.id.toString())
          //     }
          //     color="inherit"
          //   />
          // </BootstrapTooltip>,
        ];
      },
    },
  ];

  const { mutateAsync: updateAsync, isPending: isEditLoading } = useMutation({
    mutationFn: async (body: any) => {
      const response = await fetch(API_URL + "provinces/" + body.id, {
        method: "PUT",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      notifications.show("خطا در دریافت اطلاعات", {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log("eee", error);
    },
  });

  const { mutateAsync: deleteAsync, isPending: isDeleteLoading } = useMutation({
    mutationFn: async () => {
      const response = await fetch(API_URL + "provinces/" + provinceId, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Aceept: "application/json",
        },
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      notifications.show("خطا در دریافت اطلاعات", {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log(error);
    },
  });

  const [provinceId, setProvinceId] = useState("");

  const [anchorDeleteEl, setAnchorDeleteEl] =
    useState<HTMLButtonElement | null>(null);
  const openDeletePopover = Boolean(anchorDeleteEl);
  const idDeletePopover = openDeletePopover ? "simple-popover" : undefined;
  const handleDeleteClick = (
    event: MouseEvent<HTMLButtonElement>,
    id: string
  ) => {
    setAnchorDeleteEl(event.currentTarget);
    setProvinceId(id);
  };

  const [getProvince, setProvince] = useState<IProvince>();
  const handleShowCitiesClick = (province: IProvince) => {
    setProvince(province);
    setOpenCities(true);
  };
  const handleDeletePopoverClose = () => {
    setAnchorDeleteEl(null);
  };
  const handleDelete = async () => {
    try {
      const res = await deleteAsync();
      if (res.status) {
        notifications.show("حذف با موفقیت انجام شد!", {
          severity: "success",
          autoHideDuration: 5000,
        });
      } else {
        notifications.show("خطا در حذف!", {
          severity: "error",
          autoHideDuration: 5000,
        });
      }
    } catch (error) {
      console.log("🚀 ~ handleDelete ~ error:", error);
      notifications.show("خطا در حذف!", {
        severity: "error",
        autoHideDuration: 5000,
      });
    } finally {
      refetch();
      handleDeletePopoverClose();
    }
  };

  function EditToolbar() {
    return (
      <GridToolbarContainer>
        <Button
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => setOpenNewProvince(true)}
        >
          استان جدید
        </Button>
      </GridToolbarContainer>
    );
  }
  const handleEditClick = (id: GridRowId) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleSaveClick = (id: GridRowId) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const processRowUpdate = async (newRow: GridRowModel) => {
    const updatedRow = { ...newRow, isNew: false };
    const res = await updateAsync(updatedRow);
    if (res.status) {
      refetch();
      setRows(
        rows.map((row: any) => (row.id === newRow.id ? updatedRow : row))
      );
      notifications.show("تغییرات اعمال شد!", {
        severity: "success",
        autoHideDuration: 5000,
      });
    } else {
      notifications.show("مشکل در ذخیره ساز!", {
        severity: "error",
        autoHideDuration: 5000,
      });
    }
    return updatedRow;
  };

  const handleCancelClick = (id: GridRowId) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row: any) => row.id === id);
    if (editedRow!.isNew) {
      setRows(rows.filter((row: any) => row.id !== id));
    }
  };

  const [openCities, setOpenCities] = useState(false);
  return (
    <>
      <PopoverComponent
        caption=" حذف انجام شود؟"
        anchorEl={anchorDeleteEl}
        handlePopoverClose={handleDeletePopoverClose}
        handler={handleDelete}
        id={idDeletePopover}
        isLoading={isDeleteLoading}
        open={openDeletePopover}
        key={"delete"}
      />
      <Cities
        open={openCities}
        setOpen={setOpenCities}
        provinceInfo={getProvince as IProvince}
        user={user as IUser}
        refetch={refetch}
      />
      <NewProvince
        open={openNewProvince}
        setOpen={setOpenNewProvince}
        refetch={refetch}
      />

      <Box
        sx={{
          width: {
            xs: 370, // عرض برای اندازه‌های کوچک
            sm: 500, // عرض برای اندازه‌های متوسط
            md: 720, // عرض برای اندازه‌های بزرگ
            lg: "calc(100% - 80px)", // عرض برای اندازه‌های خیلی بزرگ
            xl: "calc(100% - 80px)", // عرض برای اندازه‌های فوق‌العاده بزرگ
          },
        }}
      >
        {isLoading ? (
          <SkeltonProgress />
        ) : (
          <GridViewMUIX
            gridUniqueName="Provinces"
            columns={columns}
            loading={isLoading}
            EditToolbar={EditToolbar}
            rowModesModel={rowModesModel}
            processRowUpdate={processRowUpdate}
            rows={rows}
            setRowModesModel={setRowModesModel}
          />
        )}
      </Box>
    </>
  );
};

export default Province;
